/** CoursesU Mealz backend env: plugin override, then host-based prod/uat. */

// Ephemeral <html> attribute written by the Mealz Injector extension content script.
// DOM-based (not storage) on purpose: it vanishes on reload/navigation and is never set
// when the plugin is off, so disabling the plugin cleanly reverts to host-based resolution.
export const INJECTOR_ENV_ATTRIBUTE = "data-mealz-injector-env";

const SSR_BASE_URLS = {
  dev: "http://localhost:3002",
  uat: "https://ssr-api-uat.mealz.ai",
  prod: "https://ssr-api.mealz.ai",
};

const SUPPLIER_TOKEN_BASE = {
  supplierId: 7,
  origin: "coursesu",
  noSupplier: false,
  orderHistory: true,
};

function readPluginEnvOverride() {
  const override = globalThis.document?.documentElement?.getAttribute?.(INJECTOR_ENV_ATTRIBUTE);
  if (override === "dev" || override === "uat" || override === "prod") {
    return override;
  }
  return undefined;
}

function resolveEnvFromHost() {
  try {
    return new URL(globalThis.location.href).hostname === "www.coursesu.com" ? "prod" : "uat";
  } catch {
    return "uat";
  }
}

/** @returns {'dev' | 'uat' | 'prod'} */
export function resolveCoursesUEnv() {
  return readPluginEnvOverride() ?? resolveEnvFromHost();
}

export function getSsrBaseUrl() {
  return SSR_BASE_URLS[resolveCoursesUEnv()];
}

export function getCoursesUSupplierToken() {
  const domain = resolveCoursesUEnv() === "prod" ? "miam.coursesu.web" : "miam.test";
  return btoa(JSON.stringify({ ...SUPPLIER_TOKEN_BASE, domain }));
}
